import React from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import InvitationForm from '../../partials/invitation-form';
import classes from './invitation-popup.scss';
const InvitationPopup = () => /*#__PURE__*/React.createElement(ControlDialog, {
  open: true,
  showCloseButton: false,
  content: /*#__PURE__*/React.createElement(InvitationForm, null),
  dialogClass: classes.popup,
  bodyClassName: classes.popupBody
});
export default InvitationPopup;